<h2>{{ data.title }}</h2>

<div class="content">
  <p>{{ data.message }}</p>
</div>

<div class="actions">
  <button mat-stroked-button color="primary" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button color="warn" (click)="confirm()">{{ (data.confirmLabel || 'COMMON.CONFIRM') | translate }}</button>
</div>
